import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

interface CopyButtonProps {
  text: string;
  primaryColor: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({ text, primaryColor }) => {
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(text);
  };

  return (
    <Tooltip title="Copy to clipboard">
      <IconButton
        className="custom-copy-icon"
        onClick={handleCopyToClipboard}
        sx={{
          position: "absolute",
          top: "10px",
          right: "10px",
          "&.MuiIconButton-root": {
            color: `${primaryColor}`,
            "&  svg": {
              width: 18,
              height: 18,
            },
          },
          "&:hover  ": {
            backgroundColor: `${primaryColor} !important`,
            color: `#fff !important`,
            "&  svg": {
              color: `#fff !important`,
            },
          },
        }}
      >
        <ContentCopyIcon sx={{ color: `${primaryColor}` }} />
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;

